(() => {
  const bar = document.getElementById('StickyAtc');
  if (!bar) return;

  const pkgRoot = document.querySelector('[data-emma-pkg]');
  const pkgBtn = document.querySelector('[data-emma-pkg-cta]');
  const sourceBtn = pkgBtn || document.getElementById(bar.dataset.sourceButton || '');
  if (!sourceBtn) return;

  if (bar.parentElement !== document.body) {
    document.body.appendChild(bar);
  }

  const stickyBtn = bar.querySelector('[data-sticky-atc-button]');
  if (!stickyBtn) return;
  const stickySpan = stickyBtn.querySelector('span');

  function sendGaEvent(eventName, params) {
    params = params || {};
    params.transport_type = 'beacon';
    if (typeof window.gtag === 'function') {
      try {
        window.gtag('event', eventName, params);
      } catch (err) {}
    }
    if (window.dataLayer && typeof window.dataLayer.push === 'function') {
      try {
        window.dataLayer.push(Object.assign({ event: eventName }, params));
      } catch (err) {}
    }
  }

  function money(cents) {
    const n = Number(cents) || 0;
    if (n % 100 === 0) return '$' + String(n / 100);
    return '$' + (n / 100).toFixed(2);
  }

  function pkgCents() {
    if (!pkgRoot) return 799;
    const radio = pkgRoot.querySelector('.emma-pkg__radio:checked') || pkgRoot.querySelector('.emma-pkg__radio');
    let cents = Number(radio && radio.getAttribute('data-cents')) || 0;
    const addon = pkgRoot.querySelector('[data-emma-pkg-addon]');
    if (addon && addon.checked) cents += Number(addon.getAttribute('data-cents')) || 0;
    return cents;
  }

  const syncState = () => {
    stickyBtn.disabled = sourceBtn.disabled;
    if (sourceBtn.disabled && stickySpan) {
      stickySpan.textContent = 'Sold out';
      return;
    }
    if (pkgRoot && stickySpan) {
      const pkgLabel = pkgRoot.querySelector('[data-emma-pkg-cta-label]');
      stickySpan.textContent = pkgLabel && pkgLabel.textContent.trim()
        ? pkgLabel.textContent.trim()
        : 'Add to Cart · ' + money(pkgCents());
      return;
    }
    const sourceSpan = sourceBtn.querySelector('span');
    if (sourceSpan && stickySpan && sourceSpan.textContent.trim()) {
      stickySpan.textContent = sourceSpan.textContent.trim();
    }
  };

  stickyBtn.addEventListener('click', () => {
    if (sourceBtn.disabled) return;
    stickyBtn.disabled = true;

    window.emmaCtaLocation = 'sticky_bar';

    const titleEl = document.querySelector('.product__title h1, h1.product__title');
    const prodTitle = titleEl ? titleEl.textContent.trim() : document.title;
    const stickyBtnText = stickyBtn.querySelector('span')?.textContent.trim() || 'Add to Cart';

    let priceVal = 7.99;
    const numMatch = stickyBtnText.match(/([0-9]+(?:\.[0-9]{2})?)/);
    if (numMatch) {
      priceVal = parseFloat(numMatch[1]);
    } else if (pkgRoot) {
      priceVal = pkgCents() / 100;
    } else {
      const priceEl = document.querySelector('[id^="price-"] .price-item--regular, [id^="price-"] .price-item--sale');
      if (priceEl) {
        const parsed = parseFloat(priceEl.textContent.replace(/[^0-9.]/g, ''));
        if (!isNaN(parsed) && parsed > 0) priceVal = parsed;
      }
    }

    if (!pkgRoot) {
      sendGaEvent('click_sticky_atc', {
        cta_location: 'sticky_bar',
        button_text: stickyBtnText,
        product_title: prodTitle,
        value: priceVal,
        currency: 'USD'
      });
    }

    sourceBtn.click();
    setTimeout(() => {
      syncState();
      window.emmaCtaLocation = null;
    }, 1500);
  });

  const updateVisibility = () => {
    const rect = sourceBtn.getBoundingClientRect();
    const show = rect.bottom < 0;
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    document.body.classList.toggle('sticky-atc-active', show);
  };

  window.addEventListener('scroll', updateVisibility, { passive: true });
  window.addEventListener('resize', updateVisibility, { passive: true });

  if (pkgRoot) {
    pkgRoot.addEventListener('change', syncState);
  }

  updateVisibility();
  syncState();

  const form = sourceBtn.closest('form');
  if (form) {
    form.addEventListener('change', syncState);
  }
  const mo = new MutationObserver(syncState);
  mo.observe(sourceBtn, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true });
})();
